import http from '../../services/http-common';
import securityService from '../security/security.service';

class BuyerService {
  getBuyerForList() {
    return http.get(`/buyer/db/table`);
  }
  _buyerOptionalCols = null;
  _buyerOptionalColsPromise = null;

  getBuyerColumns() {
    return http.get(`/buyer/db/columns`);
  }

  // call this ONCE before rendering BuyerInput
  async initBuyerOptionalColumns() {
    if (this._buyerOptionalCols) return this._buyerOptionalCols;
    if (this._buyerOptionalColsPromise) return this._buyerOptionalColsPromise;

    this._buyerOptionalColsPromise = this.getBuyerColumns()
      .then((res) => {
        // adjust path to your backend response shape
        // if backend: res.json({ data: { optionalColumns: [...] }})
        const cols = res?.data?.data?.optionalColumns || res?.data?.optionalColumns || [];
        this._buyerOptionalCols = cols;
        return cols;
      })
      .finally(() => {
        this._buyerOptionalColsPromise = null;
      });

    return this._buyerOptionalColsPromise;
  }

  // synchronous: uses cached optional columns
  getColumns() {
    const optionalCols = this._buyerOptionalCols || [];
    const has = (c) => optionalCols.includes(c);

    const columns = [
      { field: "buyerNTNCNIC", headerText: "NTN/CNIC", dataType: "String", width: "140px", textAlign: "right", headerTextAlign: "center", other: [] },
      { field: "buyerBusinessName", headerText: "Business Name", width: "220px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerProvinceName", headerText: "Province", width: "140px", textAlign: "left", headerTextAlign: "center", other: [] },
      { field: "buyerAddress", headerText: "Address", width: "260px", textAlign: "left", headerTextAlign: "center", other: [] },
    ];

    if (has("buyerContactPerson")) columns.push({ field: "buyerContactPerson", headerText: "Contact Person", width: "170px", textAlign: "left", headerTextAlign: "center", other: [] });
    if (has("buyerContactNumber")) columns.push({ field: "buyerContactNumber", headerText: "Contact Number", width: "170px", textAlign: "left", headerTextAlign: "center", other: [] });
    if (has("buyerSTRN")) columns.push({ field: "buyerSTRN", headerText: "STRN", width: "130px", textAlign: "left", headerTextAlign: "center", other: [] });
    if (has("buyerCNIC")) columns.push({ field: "buyerCNIC", headerText: "CNIC", width: "150px", textAlign: "left", headerTextAlign: "center", other: [] });

    return columns;
  }
  // getColumns(){
  //   let columns = [
  //     { field: "buyerNTNCNIC", headerText:'NTN/CNIC', dataType:'Int', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
  //     { field: "buyerBusinessName", headerText:'Business Name', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
  //     { field: "buyerProvinceName", headerText:'Province', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
  //     { field: "buyerAddress", headerText:'Address', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
  //   ];
  //   return columns;
  // }
  // g
  
  
  getCompanyView() {
    return http.get(`/digitalInvoicing/getCompanyView`);
  }
  getProvincesDD(id){
    return http.get(`/digitalInvoicing/pdi/v1/provinces?CompanyID=${id}`);

  }
  insert(data) {
    return http.post(`/buyer/db/add`, data);
  }
  update(data) {
    return http.put(`/buyer/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/buyer/db/delete/${PropertyID}`);
  }
}

export default new BuyerService();